import React from 'react'

import styles from './ScanlineOverlay.module.css'

interface ScanlineOverlayProps {
  flicker?: boolean
}

const ScanlineOverlay: React.FC<ScanlineOverlayProps> = ({ flicker = false }) => {
  return (
    <div className={`${styles.overlay} ${flicker ? styles.flicker : ''}`}>
      <div className={styles.scanlines} />
      <div className={styles.crtEffect} />
      <div className={styles.vignette} />
      {flicker && <div className={styles.flickerLayer} />}
    </div>
  )
}

export default ScanlineOverlay
